module.exports = __webpack_public_path__ + "static/media/menu-expand.f433c049.svg";